<template>
    <div>
        <div v-for="data in action_array" class="text-center">
            <b-row sm="12">
                <b-col sm="4" class="col text-right">
                    <label>{{data.name}}</label>
                </b-col>
                <b-col sm="3">
                    <b-form-select v-model="data.action"
                                   :options="action_item">
                    </b-form-select>
                </b-col>
                <b-col sm="3">
                    <input class="form-control"
                           v-model="data.fee"
                           type="number"/>
                </b-col>
            </b-row>
            <br>
        </div>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
        <br/>
<!--        <pre class="alert alert-primary text-left">{{ action_array }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "edit-shipping-modal",
        data(){
          return {
              action_array : [],
              action_item :[
                  {value:0, text:"ลด"},
                  {value:1, text:"เพิ่ม"}
              ],
          }
        },
        created(){
            this.$store.dispatch('TransportType/setTransportTypes').then(()=>{
                this.transportType.forEach(transport=>{
                    let data = {
                        name : transport.name,
                        transport_id : transport.id,
                        fee : 0,
                        action : 1
                    };
                    this.action_array.push(data);
                })
            });
        },
        computed:{
            ...mapState({
                transportType:state=>{
                    return state.TransportType.transportTypeList.filter(data=>data.id != 4);
                },
            }),
        },
        methods:{
            submitData(){
                this.$emit('submit',this.action_array);
                this.action_array = [];
                this.transportType.forEach(transport=>{
                    let data = {
                        name : transport.name,
                        transport_id : transport.id,
                        fee : 0,
                        action : 1
                    };
                    this.action_array.push(data);
                })
            },
            cancelData(){
                this.$emit('submit',0)
                this.action_array = [];
                this.transportType.forEach(transport=>{
                    let data = {
                        name : transport.name,
                        transport_id : transport.id,
                        fee : 0,
                        action : 1
                    };
                    this.action_array.push(data);
                })
            }
        }
    }
</script>

<style scoped>

</style>
